import { TreatmentBundle } from '@customTypes/TreatmentBundle'
import { useChoiceState } from '@context/ChoiceContext'
import useCategorizedTreatments from './useCategorizedTreatments'
import { useCityTreatments } from './useCityTreatments'
import { useIsCityVariant } from './useIsCityVariant'
import { useAllClinicsTreatments } from './useAllClinicsTreatments'
import { useIsAllClinicsVariant } from './useIsAllClinicsVariant'

export const useTreatmentPurpose = () => {
  const isCityVariant = useIsCityVariant()
  const isAllClinicsVariant = useIsAllClinicsVariant()
  const { data: categorizedTreatments } = useCategorizedTreatments()
  const { data: cityCategorizedTreatments } = useCityTreatments()
  const { data: allClinicsTreatments } = useAllClinicsTreatments()
  const { treatmentBundleTypeReferenceId } = useChoiceState()

  const treatments = (() => {
    if (isAllClinicsVariant) return allClinicsTreatments?.categorizedTreatments
    if (isCityVariant) return cityCategorizedTreatments?.categorizedTreatments
    return categorizedTreatments
  })()

  const findTreatment = (treatment: Partial<TreatmentBundle>) =>
    treatment.referenceId === treatmentBundleTypeReferenceId && treatment.treatmentPurposeReferenceId
  const category = treatments?.find((category) => category.treatmentBundles.some(findTreatment))
  const treatment = category?.treatmentBundles.find(findTreatment)

  return treatment?.treatmentPurposeReferenceId
}
